module.exports = __webpack_public_path__ + "img/mrxweb.dc0fca82.svg";